import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.0125 9L10.3875 14.625H8.81251L13.875 9.5625H2.28751V8.4375H13.875L8.81251 3.375H10.3875L16.0125 9Z",
		fill: "currentColor"
	})
});
export default SvgRightArrow;
